import { ApolloClient } from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import {ErrorResponse, onError} from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { withClientState } from 'apollo-link-state';
import {GraphQLError} from "graphql";
import { persistCache } from 'apollo-cache-persist';

export async function createClient(defaults: any) {
    const cache = new InMemoryCache({});

    const client = new ApolloClient({
        link: ApolloLink.from([
            onError(({ graphQLErrors, networkError } : ErrorResponse) => {
                if (graphQLErrors) {
                    graphQLErrors.map(({message: msg, locations, path} : GraphQLError) =>
                        console.log(
                            `[GraphQL error]: Message: ${msg}, Location: ${locations}, Path: ${path}`,
                        ),
                    );
                }
                // @ts-ignore
                if (networkError && networkError.statusCode === 401){
                    window.location.reload();
                }
                if (networkError) {
                    console.log(`[Network error]: ${networkError}`);
                }
            }),
            withClientState({
                cache,
                resolvers: [],
                defaults
            }),
            new HttpLink({
                uri: window.location.origin + "/api",
                credentials: 'same-origin'
            })
        ]),
        cache
    });
    await persistCache({
        cache,
        storage: window.sessionStorage
    });
    return client;

}


// WEBPACK FOOTER //
// ./src/client.ts